<template>
    <nav>
        <v-snackbar v-model="notifMSG" top>
            {{ notifText }}
            <v-btn color="pink" text @click="notifMSG = false"> Close</v-btn>
        </v-snackbar>
        <v-app-bar
            app
            flat
            height="60"
            style="width: auto;"
            elevation="1"
            color="white"
        >
            <v-btn
                color="white"
                elevation="undefined"
                fab
                small
                @click=" $vuetify.breakpoint.smAndDown ?
                  setDrawer(!drawer) :
                  setMiniDrawer(!miniDrawer)"
            >
                <v-icon v-if="miniDrawer && !$vuetify.breakpoint.smAndDown">
                    mdi-view-quilt
                </v-icon>

                <v-icon v-else>
                    mdi-menu
                </v-icon>
            </v-btn>

            <v-toolbar-title class="hidden-sm-and-down ml-2" v-text="$route.name"/>

            <v-spacer/>

            <v-img
                src="@/assets/ICON.png"
                max-height="100"
                max-width="115"
                id="mainLogo"
            ></v-img>
            <v-spacer></v-spacer>

            <div class="mx-3"/>

            <v-menu
                bottom
                left
                offset-y
                origin="top right"
                transition="scale-transition"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ attrs, on }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-1">
                        <v-badge
                            color="green"
                            :content="notificationsTotalBell"
                            :value="notificationsTotalBell"
                            overlap
                            show
                        >
                            <v-icon>notifications</v-icon>
                        </v-badge>
                    </v-btn>
                </template>

                <v-card max-width="450" min-width="400" class="mx-auto">
                    <v-toolbar>
                        <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
                        <v-toolbar-title>Unread: {{ notificationsTotal }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn text small class="text-capitalize" @click="menu = false" link router to="/notifications">
                            View All Notifications
                        </v-btn>
                    </v-toolbar>
                    <v-list
                        id="scroll-target"
                        three-line
                        max-height="300"
                        class="overflow-x-auto"
                        nav
                        v-if="notificationsTotal !== 0"
                    >
                        <template v-for="(item, index) in notifications">
                            <!--
                          <v-subheader
                            v-if="item.Status"
                            :key="item.Status"
                            v-text="item.Status"
                          ></v-subheader>

                          <v-divider
                            v-else-if="item.divider"
                            :key="index"
                            :inset="item.inset"
                          ></v-divider>
                          -->
                            <v-list-item :key="index" v-scroll:#scroll-target="onScroll">
                                <v-list-item-avatar>
                                    <v-img v-bind:src="item.createdBy.Image"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content style="align-self: auto">
                                    <v-list-item-title
                                        v-html="item.createdBy.Name"
                                    ></v-list-item-title>
                                    <v-list-item-subtitle
                                        v-html="item.title"
                                    ></v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-html="item.createdAt"
                                        class="font-weight-light font-italic"
                                        style="font-size:11px;"
                                    ></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text>
                                        <v-btn icon title="Mark as Read">
                                            <v-icon small @click="readNotification(item)"
                                            >mdi-bell-remove-outline
                                            </v-icon>
                                        </v-btn>
                                    </v-list-item-action-text>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
            </v-menu>

            <!-- <v-menu
              bottom
              left
              offset-y
              origin="top right"
              transition="scale-transition"
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn icon v-bind="attrs" v-on="on" class="ml-1">
                  <v-icon> mdi-message</v-icon>
                </v-btn>
              </template>
            </v-menu> -->

            <!-- <onlineListDialog /> -->

            <v-btn min-width="0" text @click="logoutUser" depressed>
                <v-icon right>exit_to_app</v-icon>
            </v-btn>
        </v-app-bar>
    </nav>
</template>

<script>
    // Components
    import {mapActions} from "vuex";

    // Utilities
    import {mapState, mapMutations} from "vuex";
    import axios from "axios";
    import moment from "moment";
    import DateTimeUtil from '../../../../../utils/date-time.util';
    import NotificationService from '../../../../service/notification.service';
    // import onlineListDialog from '../../../../components/chat/onlineListDialog'
    const url = require("@/client_config/config").url;

    export default {
        name: "DashboardCoreAppBar",

        // components: {onlineListDialog},

        props: {
            value: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            notifications: [],
            notificationsTotal: 0,
            notificationsTotalBell: 0,
            notifMSG: false,
            notifText: "",
            notifCount: 10,
            userID: localStorage.getItem('userID')
        }),
        created() {
            this.getNotifications();
        },
        computed: {
            ...mapState(["miniDrawer", "drawer"]),
        },
        methods: {
            ...mapMutations({
                setDrawer: "SET_DRAWER",
                setMiniDrawer: "SET_MINI_DRAWER"
            }),

            initialize() {
                this.notifications = [];
            },
            ...mapActions(["logout"]),
            async logoutUser() {
                const response = await axios.post(`${url}/users/logout`);

                if (response.data.success) {
                    await this.logout();
                    window.location.href = "/";
                }
            },

            getNotifications() {
                NotificationService.getAuthUserUnreadNotifications()
                    .then((response) => {
                        const {docs, totalDocs} = response.data;
                        this.notificationsTotal = totalDocs || 0;
                        this.notifications = docs.map(notification => {
                            notification.createdAt = DateTimeUtil.toLocalDateTime(notification.createdAt);
                            return notification;
                        }).filter(item => item.createdBy !== null);

                        this.notificationsTotalBell = totalDocs > 100 ? '99+' : totalDocs;
                    });
            },

            readNotification(notification) {
                const payload = {
                    notificationIds: [notification._id]
                };
                NotificationService.readAuthUserNotifications(payload)
                    .then((response) => {
                        alert(response.data.success);
                        this.notificationsTotal -= payload.notificationIds.length;
                        this.notifications.splice(this.notifications.indexOf(notification), 1);
                    });
            },

            computeDate(dateNotif) {
                var dt = new Date();
                var dat = moment(dt).format("YYYY-MM-DD HH:mm:ss");
                dat = moment(dat);
                var differenceInMs2 = dat.diff(dateNotif); // diff yields
                var duration = moment.duration(differenceInMs2); // moment.duration accepts ms
                var differenceInSeconds = Math.floor(duration.asSeconds());
                var differenceInMinutes = Math.floor(duration.asMinutes());
                var differenceInHours = Math.floor(duration.asHours());
                let differenceInDays = Math.floor(duration.asDays());

                let result = 0;
                if (
                    differenceInSeconds > 0 &&
                    differenceInMinutes <= 0 &&
                    differenceInHours <= 0
                ) {
                    result = differenceInSeconds + " second(s) ago.";
                } else if (
                    differenceInSeconds > 0 &&
                    differenceInMinutes > 0 &&
                    differenceInHours <= 0
                ) {
                    result = differenceInMinutes + " minute(s) ago.";
                } else if (
                    differenceInSeconds > 0 &&
                    differenceInMinutes > 0 &&
                    differenceInHours > 0 &&
                    differenceInHours <= 24
                ) {
                    result = differenceInHours + " hour(s) ago.";
                } else if (
                    differenceInSeconds > 0 &&
                    differenceInMinutes > 0 &&
                    differenceInHours > 0 &&
                    differenceInHours > 24 &&
                    differenceInDays <= 31
                ) {
                    result = differenceInDays + " day(s) ago.";
                } else {
                    result = moment(dateNotif).format("MMM D YYYY");
                }
                return result;
            },
            viewNotification(notificationID) {
                //confirm("Are you sure you want to remove this notification?") &&
                this.notificationViewed(notificationID);
                this.notifMSG = true;
                this.notifText = "The notification has been successfully removed.";
                this.notificationsTotalBell -= 1;
            },
            notificationViewed(id) {
                axios.put(`${url}/notifications/${id}`).then((response) => {
                    this.getNotifications();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                });
            },
            onScroll(e) {
                if (e.target.scrollTop + 300 === e.target.scrollHeight) {
                    this.notifCount += 10;
                    this.getNotifications();
                }
            },
            onClickRemove() {
                this.notificationsTotal -= 1;
            },
        },
    };
</script>
